import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { Fade } from '@mui/material';
import { TextChatMessage } from '../../types';
import VRSIcon from '../common/Icons/VRS';
import { CallRequestType } from '../../customer-call-sdk';

const StyledMessage = styled.div`
    display: flex;
    margin-bottom: 0.5rem;
    transition: all 3000ms ease-in;
    &.incoming {
        flex-direction: row;
    }
    &.outgoing {
        flex-direction: row-reverse;
    }
    .text-container {
        padding: 0.75rem 1rem;
        border-radius: 10px;
        max-width: 246px;
    }
    .text-container.incoming {
        background-color: #454c54;
    }
    .text-container.outgoing {
        background-color: #018744;
    }
    .text {
        color: #ffffff;
        font-size: 16px;
        font-weight: 600;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        white-space: pre-line;
    }
    .avatar-placeholder {
        height: 40px;
        width: 40px;
        margin-right: 0.5rem;
    }
    .avatar {
        background-color: #646b74;
        height: 40px;
        width: 40px;
        border-radius: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.5rem;
    }
    .avatar-icon {
        height: 32px;
        width: 32px;
        color: #fff;
    }
    .starting-message {
        margin-top: 1.5rem;
    }
`;

interface MessageProps {
    message: TextChatMessage;
    isContinuousMessage: boolean;
    callRequestType: CallRequestType;
}
/**
 * Message component
 */
const Message: React.FC<MessageProps> = ({ message, isContinuousMessage, callRequestType }) => {
    const renderAvatar = () => {
        if (callRequestType) {
            return null;
        }
        if (message.type === 'outgoing') {
            return null;
        }
        if (isContinuousMessage) {
            return <div className="avatar-placeholder" />;
        }
        return (
            <div className="avatar">
                <VRSIcon className="avatar-icon" />
            </div>
        );
    };
    return (
        <Fade in timeout={800}>
            <StyledMessage
                className={cx(message.type, {
                    'starting-message': !isContinuousMessage,
                })}
            >
                {renderAvatar()}
                <div className={cx('text-container', message.type)}>
                    <div className="text">{message.text}</div>
                </div>
            </StyledMessage>
        </Fade>
    );
};

export default Message;
